import React from 'react'

import EmbededReviews from './EmbededReviews'
import OceanPosibilities from './OceanPosibilities'
import Showcases from './Showcases'

export default function PageTemplates() {
  return (
    <React.Fragment>
      <Showcases />
      <EmbededReviews />
      <OceanPosibilities />
    </React.Fragment>
  )
}
